import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import DataGrid from '../../../components/DataGrid/DataGrid';
import { columns } from './plantParameters';
import EditParametersPlantsModal from '../../../components/Modals/ParametersModals/EditParametersPlantsModal';
import { Button } from '../../../components/common';

export default function PlantSimulationParameters(props) {
  const [modalOpen, setModalOpen] = useState(false);

  const updateParameters = () => {};

  const handleSelectionChange = (newSelection) => {
    props.setSelection(newSelection);
    const selectionDataFiltered = props.data?.filter((param) => {
      if (newSelection.includes(param.id)) return param;
      else return null;
    });
    props.setPlantParameters(selectionDataFiltered);
  };

  useEffect(() => {
    handleSelectionChange(props.selection);
    //eslint-disable-next-line
  }, [props.data]);

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          onClick={() => setModalOpen(true)}
          disabled={props.selection.length === 0}
        >
          EDYTUJ WSKAŹNIK
        </Button>
        <DataGrid
          toolbar
          checkboxSelection
          columnData={columns}
          rowData={props.data?.sort((a, b) => a.id - b.id)}
          sx={{ boxShadow: 3, mt: 2 }}
          onSelectionModelChange={handleSelectionChange}
          selectionModel={props.selection}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
      {modalOpen && (
        <EditParametersPlantsModal
          local
          open={modalOpen}
          setOpen={setModalOpen}
          selected={props.selection}
          data={props.data}
          setData={props.setData}
          selectionData={props.plantParameters}
          updateParameters={updateParameters}
        />
      )}
    </>
  );
}
